import { render } from "./Form.vue?vue&type=template&id=dd0738d6&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=dd0738d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dd0738d6"

export default script